export const getNullSafeValue = (value: any) => (value !== undefined && value !== null)
  ? value
  : '';
